import React, {useRef, useMemo} from "react";
import { Form } from 'antd';
import { addWebsite } from "../../stateManagement/actions/data";
import { useDispatch } from "react-redux";
import { ADMIN_ACCESS } from "../../utils/constants";
import BasicFormButtons from "./basicFormButtons";
import SelectableFormField from "./selectableFormField";
import InputFormField from "./inputFormField";

const NewWebsiteForm = ({publishersList, reloadData}) => {

    // Form reference for resetting
    const formRef = useRef(null);

    const dispatch = useDispatch();

    // Memoize options to prevent unnecessary recalculations
    const publisherOptions = useMemo(() => 
        [...new Set(
            publishersList
                .map(item => item.returnedValue)
                .filter(item => item !== ADMIN_ACCESS)
        )], 
        [publishersList]
    );

    //Reset form fields
    const handleReset = () => formRef.current?.resetFields();

    // Handle form submission
    const onFinish = (values) => {
        // Dispatch action to add website
        dispatch(addWebsite(values))
        // Reset form and reload data
        handleReset();
        reloadData();
    };

    return(
        <Form ref={formRef} onFinish={onFinish}>
            <InputFormField label="Domain:" name="domain"/>
            <SelectableFormField 
                name="parent"
                label="Parent:" 
                options={publisherOptions}
            />
            <BasicFormButtons handleReset={handleReset}/>
        </Form>
    )
}

export default NewWebsiteForm;